import clsx from 'clsx'

import { Log, MandatoryLogInformation } from '@/types/logs'
import { getMandatoryFieldsForLog } from '../../../helpers/getMandatoryFieldsForLog'

import styles from './MissingInfo.module.scss'

interface Props {
    log?: Log
    label: string
    field: MandatoryLogInformation
}

export const MissingInfo = ({ log, label, field }: Props) => {
    const requiredFields = log ? getMandatoryFieldsForLog(log) : []
    const isFieldRequired = requiredFields.includes(field)

    if (!isFieldRequired) {
        return '-'
    }

    return <p className={clsx(styles.text, styles.missing)}>Add {label}</p>
}
